import React from "react"

import { StandardBlockWrapper } from "./standardBlockWrapper"
import { PortableTextBlock } from "../sanity/portableTextBlock"

const IntroText = ({ padding, backgroundColor, heading, _rawText }) => {
  return (
    <StandardBlockWrapper
      padding={padding}
      backgroundColor={backgroundColor}
      className="grid grid-cols-14 gap-y-7"
    >
      <div className="col-start-2 col-end-14 prose md:prose-lg max-w-none md:col-end-10 lg:col-end-8 xl:col-start-3">
        <h1 className="font-display break-words">{heading}</h1>
      </div>
      <div className="col-start-2 col-end-14 prose md:prose-lg max-w-none md:col-start-7 lg:col-start-9 lg:mt-24 xl:col-start-9 xl:col-end-13">
        <PortableTextBlock text={_rawText} />
      </div>
    </StandardBlockWrapper>
  )
}

export default IntroText
